export default {
      id: "icon-footer-pro-usage",
      viewBox: "0 0 41 41",
      url: "../icon/" + "icons.svg#icon-footer-pro-usage",
      toString: function () {
        return this.url;
      }
    }